const key = (context) => "satin-job:" + context;
const cache = new Map();
export function savedSatinJob(context) {
  if (cache.has(context)) return cache.get(context);
  try {
    return JSON.parse(localStorage.getItem(key(context)) || "null");
  } catch {
    return null;
  }
}
async function record(context, value) {
  const db = await new Promise((resolve, reject) => {
    const req = indexedDB.open("embroidery-satin-jobs", 1);
    req.onupgradeneeded = () => req.result.createObjectStore("jobs");
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(
        "jobs",
        value === undefined ? "readonly" : "readwrite"
      );
      const store = tx.objectStore("jobs");
      const req =
        value === undefined ? store.get(context) : store.put(value, context);
      tx.oncomplete = () => resolve(value === undefined ? req.result : value);
      tx.onerror = tx.onabort = () =>
        reject(tx.error || new Error("Could not save Trace progress."));
    });
  } finally {
    db.close();
  }
}
export async function loadSatinJob(context) {
  const value = await record(context);
  if (value !== undefined) {
    cache.set(context, value);
    return value;
  }
  const legacy = savedSatinJob(context);
  if (legacy) await saveSatinJob(context, legacy);
  return legacy;
}
export async function listSatinJobs() {
  const db = await new Promise((resolve, reject) => {
    const req = indexedDB.open("embroidery-satin-jobs", 1);
    req.onupgradeneeded = () => req.result.createObjectStore("jobs");
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction("jobs", "readonly");
      const store = tx.objectStore("jobs");
      const keys = store.getAllKeys();
      const values = store.getAll();
      tx.oncomplete = () =>
        resolve(keys.result.map((context, index) => ({ context, value: values.result[index] })));
      tx.onerror = tx.onabort = () =>
        reject(tx.error || new Error("Could not read Trace jobs."));
    });
  } finally {
    db.close();
  }
}
export async function saveSatinJob(context, value) {
  try {
    await record(context, value);
  } catch {
    throw new Error(
      "Trace couldn’t save progress on this device. Free some browser storage and try again. Your existing design is unchanged."
    );
  }
  cache.set(context, value);
  // Remove only this migrated job, and only after its durable write succeeds.
  try {
    localStorage.removeItem(key(context));
  } catch {
    /* Storage may be blocked. */
  }
}
